import { jsx as a } from "react/jsx-runtime";
import { Typography as t } from "@mui/material";
const m = ({ variant: r = "h1", children: o, ...p }) => /* @__PURE__ */ a(
  t,
  {
    ...p,
    variant: r,
    children: o
  }
);
export {
  m as Typography,
  m as default
};
